import styled from "styled-components";

export const MessageBox = styled.div`
  background-color: #51A351;
  position: absolute;
  bottom: 1.5rem;
  z-index: 20;
  right: 1rem;
  padding: 0 1.5rem 1.5rem 1.5rem;
  min-height: 5rem;
  border-radius: .5rem;
  user-select: none;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;

  &.error {
    background-color: #FE6765;
  }
`

export const MessageDiv = styled.div`
  color: #fff;
  display: flex;
  align-items: center;
  margin-top: 1.5rem;
  gap: 1rem;
  flex-grow: 1;
  width: 100%;
`

export const MessageHeader = styled.div`
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  right: .3rem;
  position: absolute;
  cursor: pointer;
  img{
    width: .5rem;
  }
`

export const MessageIcon = styled.img`
  height: 1.2rem;
`

export const TipDiv = styled.div`
  max-width: 20rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MessageStatus = styled.h3`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
`

export const MessageText = styled.p`
  font-weight: 300;
  margin: 0;
  font-size: 14px;
`